import { formatDuration, serviceType, spaceTypeList } from './../../utils/utils.common';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { CamelCasePipe } from 'src/app/pipe/camelcase.filter/camelcase.filter.pipe';
import { exportToCsv } from 'src/app/utils/utils.common';

@Injectable({
  providedIn: 'root'
})
export class CsvService {

  constructor(
    private capitalize: CamelCasePipe
  ) { }
  

  generateTripItineraryReport(trips, date, timezone, preLevelOfServices, preSpaceTypes, preServiceAreas,user,preFleetList, prePayorsList) {
    let isEnabledOneHourException = true; 
    if (user.company 
        && user.company.hasOwnProperty('hideOneHourException')
        && user.company.hideOneHourException
    ) {
      isEnabledOneHourException = false;
    }
    const columns = [
        "AccountName",
        "RideDate",
        "VehicleNumber",
        "Driver",
        "MedicalNumber",
        "FirstName",
        "LastName",
        "LOS",
        "PickupAddress1",
        "ScheduledPickupTime",
        "PickupArrivalTime",
        "ActualPickupTime",
        "PickupOnTime",
        "DropoffAddress1",
        "ScheduledDropoffTime",
        "DropoffArrivalTime",
        "ActualDropoffTime",
        "DropoffOnTime",
        "RidePurpose",
        "AppointmentTime",
        "RideComments",
        "RideStatus",
        "DriveDurationMinutes",
        "DirectDriveDuration",
        "AuthNum",
        "WhichLeg",
        "Division",
        "Payor",
        "1-Hour Exception",
        "Cancel Reason",
        "Cancellation Notes"
    ]
    
    if (!isEnabledOneHourException) {
      columns.splice(-3, 1);
    }

    const table = [columns];
    trips.forEach(trip => {

      const displayName = trip.priorityClient.displayName.trim() || '';
      const [firstName, ...lastNameParts] = displayName.split(' ');
      const lastName = lastNameParts.length > 0 ? lastNameParts.join(' ') : '';

      let data = [
        user.displayName ? user.displayName : ' ',
        moment(trip.scheduleTime).tz(timezone).format("MM/DD/YYYY"),
        preFleetList && trip.driver && trip.driver.fleet && preFleetList[trip.driver.fleet] ? preFleetList[trip.driver.fleet].setiDecall : ' ',
        trip.driver ? trip.driver.displayName : ' ',
        trip.priorityClient.clientId,
        firstName,
        lastName,
        preSpaceTypes && preSpaceTypes[trip.spaceType] ? preSpaceTypes[trip.spaceType].title : ' ',
        trip.jobOriginAddress ? trip.jobOriginAddress : ' ',
        moment(trip.scheduleTime).tz(timezone).format("HH:mm:ss"),
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobArrived ? moment(trip.job.trackInfoJob.jobArrived.time).tz(timezone).format("HH:mm:ss") : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobStarted ?  moment(trip.job.trackInfoJob.jobStarted.time).tz(timezone).format("HH:mm:ss") : ' ',
        // pickUpOnTime,
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobStarted ?  this.isOnTime(trip.job.trackInfoJob.jobStarted.time,  trip.scheduleTime):'',
        trip.jobDestinationAddress ? trip.jobDestinationAddress : ' ',
        moment(trip.appointmentTime).tz(timezone).format("HH:mm:ss"),
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobCompleted ? moment(trip.job.trackInfoJob.jobCompleted.time).tz(timezone).format("HH:mm:ss") : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobFinished ?  moment(trip.job.trackInfoJob.jobFinished.time).tz(timezone).format("HH:mm:ss") : ' ',
        // dropOffOnTime,
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobCompleted ? this.isOnTime(trip.job.trackInfoJob.jobCompleted.time, trip.appointmentTime): '',
        trip.tripReason? trip.tripReason[0] : ' ',
        moment(trip.appointmentTime).tz(timezone).format("HH:mm:ss"),
        trip.companyNote? trip.companyNote : ' ',
        trip.status? trip.status : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobCompleted && trip.job.trackInfoJob.jobStarted ? moment(trip.job.trackInfoJob.jobCompleted.time).diff(moment(trip.job.trackInfoJob.jobStarted.time), 'minutes') : ' ',
        moment(trip.appointmentTime).diff(moment(trip.scheduleTime), 'minutes'),
        trip.authorizationNumber? trip.authorizationNumber : ' ',
        trip.tripId? trip.tripId : ' ',
        preServiceAreas && preServiceAreas[trip.serviceArea] ? preServiceAreas[trip.serviceArea].name : ' ',
        prePayorsList && prePayorsList[trip.payorId] ? prePayorsList[trip.payorId].name : ' ',
        trip.isAnHourException ? 'Yes' : '',
        trip.changeReason ? trip.changeReason : '',
        trip.cancelReasonNote ? trip.cancelReasonNote : ''
      ]
      if (!isEnabledOneHourException) {
        data.splice(-3, 1);
      }
      table.push(data)
    });

    exportToCsv(`reports-${moment(date[0]).tz(timezone).format("MM-DD-YYYY")}-${moment(date[1]).tz(timezone).format("MM-DD-YYYY")}.csv`, table);
  }

  isOnTime(scheduledTime, arrivedTime) {
    // const scheduled = moment(scheduledTime);
    // const arrived = moment(arrivedTime);
  
    // const diffInMinutes = arrived.diff(scheduled, 'minutes');
  
    // if (diffInMinutes <= 15 && diffInMinutes >= -10080) {
    //   return "On Time"; // On time
    // } else {
    //   return "Late"; // Late
    // }
    return "";
  }

  generateOtpReport(data) {
    const {
      trips,
      preDrivers,
      preLevelOfServices,
      preSpaceTypes,
      timeZone,
      isEnabledOneHourException,
      prePayorsList
    } = data;

    const columns = [
      "Trip ID",
      "Member ID",
      "Patient",
      "PU Date",
      "DO Date",
      "PU Time",
      "DO Time",
      "Pickup Address",
      "Dropoff Address",
      "LOS",
      "Driver",
      "Trip Status",
      "Miles",
      "OTP Status",
      "OTP Minutes",
      "Payor",
      "1-Hour Violation",
      "1-Hour Exception"
    ]

    if (!isEnabledOneHourException) {
      columns.splice(-2);
    }

    const table = [columns];

    for (const trip of trips) {
      const los = preLevelOfServices[trip.los];
      const spaceType = preSpaceTypes[trip.spaceType];
      const driver = preDrivers[trip.driver];

      const row = [
        trip.tripId,
        trip.priorityClient && trip.priorityClient.clientId ? trip.priorityClient.clientId : 'N/A',
        trip.priorityClient && trip.priorityClient.displayName ? trip.priorityClient.displayName : 'N/A',
        trip.scheduleTime ? moment(trip.scheduleTime).tz(timeZone).format("MM/DD/YYYY") : 'N/A',
        trip.appointmentTime ? moment(trip.appointmentTime).tz(timeZone).format("MM/DD/YYYY") : 'N/A',
        trip.scheduleTime ? moment(trip.scheduleTime).tz(timeZone).format("HH:mm") : 'N/A',
        trip.appointmentTime ? moment(trip.appointmentTime).tz(timeZone).format("HH:mm") : 'N/A',
        trip.jobOriginAddress,
        trip.jobDestinationAddress,
        spaceType ? `${spaceType.title}` : 'N/A',
        driver ? driver.displayName : 'N/A',
        this.getTripStatus(trip),
        `${trip.milage} mi`,
        trip.tripType !== 'Normal' ? trip.pickupStatus :trip.dropOffStatus,
        trip.tripType !== 'Normal' ? trip.pickupDelayMinutes : trip.dropOffDelayMinutes,
        prePayorsList && prePayorsList[trip.payorId] ? prePayorsList[trip.payorId].name : ' ',
        trip.onboardDurationMinutes ? `${formatDuration(trip.onboardDurationMinutes)} ${trip.oneHourViolation ? '(Violation)' : ''}` : '',
        trip.isAnHourException ? 'Yes' : '',

      ]

      if (!isEnabledOneHourException) {
        row.splice(-2);
      }
      table.push(row);
    }
    exportToCsv(`trips-report-${moment(data.searchDate).tz(timeZone).format("MM-DD-YYYY")}.csv`, table);
  }

  getTripStatus(trip) {
    if (trip.jobStatus === "pending")
      return "Unassigned"
    if (trip.jobStatus === "arrived")
      return "On Scene"
    if (trip.jobStatus === "started")
      return "Member Onboard"
    if (trip.jobStatus === "onway")
      return "In Route"
    else
      return this.capitalize.transform(trip.jobStatus);
  }
}
